module.exports = __webpack_public_path__ + "img/id-card_fill.b7f2c5d5.svg";